/**
 * 数字を3桁ごとにカンマで区切る書式の文字列に変換します。
 *
 * @param {number|string} num
 * @returns {string}
 */
export function numberFormat(num) {
    return Number(num).toLocaleString('ja-JP');
}
